var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNikon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 798 204",
    width: 798,
    height: 204,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m242.84-0.02h-65.02l-28.68 78.84-20.48-78.84h-56.83l-71.17 195.58h65.03l27.13-74.24 16.9 66.05 2.05 8.19h59.9zm13.83 195.58l45.56-125.44h-65.02l-45.57 125.44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m248.62 37c1.42 7.47 6.55 13.92 14.25 17.92 7.71 4.01 17.35 5.24 26.83 3.44 9.47-1.81 17.98-6.51 23.67-13.07 5.69-6.56 8.09-14.44 6.66-21.91-1.42-7.47-6.55-13.91-14.25-17.92-7.71-4-17.36-5.24-26.83-3.43-9.47 1.8-17.98 6.5-23.67 13.06-5.69 6.56-8.09 14.44-6.66 21.91z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m482.97 69.1h-74.24l-36.87 41.47 39.94-110.59h-65.02l-71.17 195.58h65.02l18.43-50.18 8.2 50.18h66.56l-9.73-60.42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m561.82 63.46h-33.28c-29.7 0-62.47 24.07-73.22 53.76-17.41 48.13 7.17 86.53 55.3 86.53h33.28c29.69 0 62.46-24.06 73.21-53.76 16.9-48.13-7.68-86.53-55.29-86.53zm-31.75 96.77c-9.73 1.54-14.85-9.21-11.77-24.06 3.07-14.85 13.31-27.65 23.04-29.19 9.72-1.53 14.84 9.22 11.77 24.07-3.07 14.85-13.31 27.65-23.04 29.18zm235.52-91.65h-6.65c-20.48 0-45.06 15.36-48.64 19.97l6.65-18.94h-65.02l-45.57 125.44h65.02l21.51-58.88c2.56-6.66 11.26-13.83 19.45-13.83 8.71 0 11.27 7.17 8.71 13.83l-21.51 58.88h65.03l29.69-81.41c9.22-24.58-3.58-45.06-28.67-45.06z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNikon);
export default __webpack_public_path__ + "static/media/nikon.d1da9da5547da176274446085984eb58.svg";
export { ForwardRef as ReactComponent };